import React from "react"

import {
	Box,
	Button,
} from "@mui/material"
import {
	TabContext,
	TabPanel,
	Timeline,
	TimelineConnector,
	TimelineContent,
	TimelineDot,
	TimelineItem,
	timelineItemClasses,
	TimelineSeparator,
} from "@mui/lab"

import {
	t,
	Trans,
} from "@lingui/macro"
import Icon from "@mdi/react"
import {
	mdiCircle,
	mdiPlusBox,
} from "@mdi/js"

import {
	SbTab,
	SbTabList,
} from "components/commons"
import {
	TemplateStep,
} from "models"

import { TemplateActions } from "../../detail/template-actions"

interface TemplateColumnTwoProps {
	openDeleteStep: (step: TemplateStep) => void
	openEditStep: (step: TemplateStep) => void
	cloneStep: (step: TemplateStep) => void
	openNewStep: () => void
	steps: TemplateStep[]
}
interface TemplateColumnTwoState {
}
export class TemplateColumnTwo extends React.Component<TemplateColumnTwoProps, TemplateColumnTwoState> {
	static defaultProps = {}

	constructor(props: TemplateColumnTwoProps) {
		super(props)
		this.state = {}
	}

	render() {
		return (

			<TabContext value="1">
				<Box sx={{ borderBottom: 0 }}>
					<SbTabList variant="fullWidth">
						<SbTab
							disableRipple
							disableTouchRipple
							label={t({ id: "workflow.template.actions", message: "Azioni in questo workflow", })}
							value="1" />
					</SbTabList>
				</Box>
				<TabPanel value="1" sx={{ px: 0 }}>
					<Box height={"50vh"} overflow={"auto"}>
						<Timeline
							sx={{
								py: 0,
								my: 0,
								[`& .${timelineItemClasses.root}:before`]: {
									flex: 0,
									padding: 0,
								},
							}}>
							{this.props.steps.map((data: any) => (
								<TimelineItem key={data.id}>
									<TimelineSeparator>
										<TimelineDot color="secondary">
											<Box component={Icon} path={mdiCircle} size={0.85} sx={{ color: "secondary.main" }} />
										</TimelineDot>
										<TimelineConnector sx={{ backgroundColor: "primary.main" }} />
									</TimelineSeparator>
									<TimelineContent>
										<TemplateActions
											data={data}
											deleteAction={() => this.props.openDeleteStep(data)}
											editAction={() => this.props.openEditStep(data)}
											cloneAction={() => this.props.cloneStep(data)}
										/>
									</TimelineContent>
								</TimelineItem>
							))}
							<TimelineItem>
								<TimelineSeparator>
									<TimelineDot color="secondary">
										<Box component={Icon} path={mdiCircle} size={0.85} sx={{ color: "secondary.main" }} />
									</TimelineDot>
								</TimelineSeparator>
								<TimelineContent>
									<Button
										startIcon={<Icon path={mdiPlusBox} size={1} />}
										variant="contained"
										color="secondary"
										size="small"
										sx={{ mt: 1 }}
										onClick={this.props.openNewStep}>
										<Trans id="workflow.add-new-action">
											Aggiungi nuova azione
										</Trans>
									</Button>
								</TimelineContent>
							</TimelineItem>
						</Timeline>
					</Box>
				</TabPanel>
			</TabContext>

		)
	}
}
